import moment from 'moment';

const forceServerTz = (date, timezone, customFormat) => {
  const dateFormat = customFormat || 'YYYY-MM-DD';
  const strippedDate = moment(date).format(dateFormat) || moment().format(dateFormat);
  return moment.tz(strippedDate, timezone);
};

export default forceServerTz;
